import app from '@/app';
import templateUrl from './gapIdentification-search.html';

/* @ngInject */
function GapIdentificationSearchController($controller, $state, GapIdentification, Principal, $timeout, AlertService) {
	var $ctrl = this;
	var resource = GapIdentification;
	$controller('AbstractPageSortController', { $controller, $ctrl: $ctrl, $state });

	var transition = $ctrl.transition;
	let debouncePromise = null;

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})


	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		resource.query(
			{
				plantype: 'GAPS',
				road: params.road,
				campaign: params.campaign,
				sort: params.sort,
				page: params.page,
				size: params.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
    $ctrl.campaign = null;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
    $ctrl.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	// -----------------------------------------
	// 🟦 Debounced Query com AngularJS ($timeout)
	// -----------------------------------------
	$ctrl.onQueryChange = function() {
		if (debouncePromise) {
			$timeout.cancel(debouncePromise);
		}

		debouncePromise = $timeout(() => {
		var pCampaign = $ctrl.campaign && $ctrl.campaign.id ? $ctrl.campaign.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;
    var pOrganization = $ctrl.organization && $ctrl.organization.id ? $ctrl.organization.id : null;

		resource.query(
			{
				plantype: 'GAPS',
        organization: pOrganization,
				road: pRoad,
				roadtype: $ctrl.roadtype,
				campaign: pCampaign,
				sort: $ctrl.sort,
				page: 0,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
		}, 400); // debounce: 400ms
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		resource.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'gapIdentification',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('gapIdentificationSearch', {
	templateUrl,
	controller: GapIdentificationSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<'
	}
});
